import * as React from 'react';
import { EEventType } from '../../types/events';
import { ESocialResponseType, ESocialType } from '../../types/social';
import { RootContext } from '../RootContainer';
import { Social } from '../../_NEXT_components/Social';
import { isApple } from '../../utils/userAgent';
import { trackSocialButtonClick } from '../../utils/tracking';
var SOCIAL_NETWORKS = [ESocialType.VK, ESocialType.Google, ESocialType.MailRu, ESocialType.Facebook, ESocialType.OK, ESocialType.AppleID];
var SOCIAL_NETWORKS_APPLE = [ESocialType.AppleID, ESocialType.Google, ESocialType.VK, ESocialType.MailRu, ESocialType.Facebook, ESocialType.OK];
export function SocialContainer(_ref) {
  var expanded = _ref.expanded,
      error = _ref.error,
      open = _ref.open,
      expand = _ref.expand,
      authenticate = _ref.authenticate,
      authenticateEmailRequired = _ref.authenticateEmailRequired,
      authenticateEmailTaken = _ref.authenticateEmailTaken,
      authenticateError = _ref.authenticateError,
      emit = _ref.emit;

  var _React$useContext = React.useContext(RootContext),
      userAgent = _React$useContext.userAgent,
      _React$useContext$dis = _React$useContext.disabledSocials,
      disabledSocials = _React$useContext$dis === void 0 ? [] : _React$useContext$dis,
      frameless = _React$useContext.frameless; // если есть хотя бы одна недоступная соцсеть из списка - показываем сразу развернутое состояние


  var isExpanded = React.useMemo(function () {
    return disabledSocials.length !== 0 || expanded;
  }, [disabledSocials, expanded]);
  var handleExpand = React.useCallback(function () {
    if (!expanded) {
      expand(!expanded);
    }
  }, [expand, expanded]);
  var socialListFull = React.useMemo(function () {
    return (isApple(userAgent) ? SOCIAL_NETWORKS_APPLE : SOCIAL_NETWORKS).filter(function (social) {
      return !disabledSocials.includes(social);
    });
  }, [userAgent, disabledSocials]);
  var socialListShort = React.useMemo(function () {
    return socialListFull.slice(0, 3);
  }, [socialListFull]);

  var handleSocialSuccess = function handleSocialSuccess(type) {
    return function (socialLoginId, email, token, userCreated) {
      authenticate({
        socialType: type,
        socialLoginId: socialLoginId,
        email: email,
        token: token,
        userCreated: userCreated
      });
    };
  };

  var handleSocialEmailRequired = function handleSocialEmailRequired(socialType, socialLoginId) {
    authenticateEmailRequired({
      socialLoginId: socialLoginId,
      socialType: socialType,
      email: '',
      phone: ''
    });
  };

  var handleSocialEmailTaken = function handleSocialEmailTaken(email, socialLoginId, socialType) {
    authenticateEmailTaken({
      email: email,
      socialLoginId: socialLoginId,
      socialType: socialType
    });
  };

  var handleSocialError = function handleSocialError(type) {
    return function () {
      authenticateError(type);
    };
  };

  var handleSocialResponse = function handleSocialResponse() {
    for (var _len = arguments.length, response = new Array(_len), _key = 0; _key < _len; _key++) {
      response[_key] = arguments[_key];
    }

    var type = response[0],
        data = response[1];

    switch (type) {
      case ESocialResponseType.UserNotFound:
        {
          var socialLoginId = data.socialLoginId,
              socialType = data.socialType,
              email = data.email,
              phone = data.phone;
          authenticateEmailRequired({
            socialLoginId: socialLoginId,
            socialType: socialType,
            email: email,
            phone: phone
          });
          break;
        }
    }
  };

  var handleSocialClick = React.useCallback(function (socialType) {
    window._socialResponse = handleSocialResponse;
    /* DEPRECATED */

    window.socialLogOnStart = handleSocialSuccess(socialType);
    window.showNeedEmailPopup = handleSocialEmailRequired;
    window.showNeedMergeEmailPopup = handleSocialEmailTaken;
    window.showErrorSocialAuth = handleSocialError(socialType);
    emit(EEventType.SocialButtonClick, {
      type: socialType
    });
    open({
      socialType: socialType
    });
    trackSocialButtonClick(socialType); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (socialListFull.length === 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Social, {
    list: socialListFull,
    listShort: socialListShort,
    error: error,
    isExpanded: isExpanded,
    expand: handleExpand,
    onClick: handleSocialClick,
    frameless: frameless
  });
}